/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { isMobile } from 'react-device-detect';
import "./style.scss";
import Marquee from "react-fast-marquee";
import { FACE_URL, REDIT_URL, TELEGRAM_URL, TWITTER_URL, YOUTUBE_URL } from "../../../const/const";

const Partners: React.FC = () => {
  return (
    <div className="partners-layout">
      <div className="layout">
        <div className="inner-layout">
          <div className="partner">
            <h4 className="title mb">Trusted Backers & Partners</h4>
            <div className="flex list-logo">
              <img className="top-left square" alt='' src='/images/home/partners/square.svg' />
              <img className="top-right square" alt='' src='/images/home/partners/square.svg' />
              <Marquee
                className="custom-marquee"
                direction="right"
                gradient={!isMobile}
                pauseOnHover
                speed={100}
                loop={0}
                autoFill
                gradientWidth={150}
              >
                <div className="logo">
                  <img className="logo-img" alt='' src='/images/home/partners/1.svg' />
                </div>
                <div className="logo">
                  <img className="logo-img" alt='' src='/images/home/partners/2.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/3.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/4.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/5.svg' />
                </div>
              </Marquee>
            </div>
            <div className="flex list-logo bottom">
              <img className="bottom-left square" alt='' src='/images/home/partners/square.svg' />
              <img className="bottom-right square" alt='' src='/images/home/partners/square.svg' />
              <Marquee
                className="custom-marquee"
                direction="left"
                gradient={!isMobile}
                pauseOnHover
                speed={100}
                loop={0}
                autoFill
                gradientWidth={150}
              >
                <div className="logo">
                  <img alt='' src='/images/home/partners/6.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/7.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/8.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/9.svg' />
                </div>
                <div className="logo">
                  <img alt='' src='/images/home/partners/10.svg' />
                </div>
              </Marquee>
            </div>
            <h4 id="community" className="title">Join Our Community</h4>
            <p className="desc">Be part of a global movement shaping DeFi + AI.</p>
            <div className="flex community">
              <img className="top-left square" alt='' src='/images/home/partners/square.svg' />
              <img className="top-right square" alt='' src='/images/home/partners/square.svg' />

              <a href={TELEGRAM_URL} target="_blank" className="logo">
                <img alt='' src='/images/home/partners/telegram.svg' />
                <p>Telegram</p>
              </a>
              <a href={TWITTER_URL} target="_blank" className="logo">
                <img alt='' src='/images/home/partners/x.svg' />
                <p>X.com</p>
              </a>
              <a href={REDIT_URL} target="_blank" className="logo">
                <img alt='' src='/images/home/partners/reddit.svg' />
                <p>Reddit</p>
              </a>
              <a href={FACE_URL} target="_blank" className="logo">
                <img alt='' src='/images/home/partners/fb.svg' />
                <p>Facebook</p>
              </a>
              <a href={YOUTUBE_URL} target="_blank" className="logo">
                <img alt='' src='/images/home/partners/youtube.svg' />
                <p>Youtube</p>
              </a>
              {/* <div className="projects">
                <div className="project">
                  <p className="name">DefAI Update</p>
                  <div className="read flex">
                    <p>Read More</p>
                    <img src='/images/home/products/arrow.svg' />
                  </div>
                </div>
                <div className="project">
                  <p className="name">New IDO Live</p>
                  <div className="read flex">
                    <p>Read More</p>
                    <img src='/images/home/products/arrow.svg' />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
